import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export function pendingPaymentItems(rows: any[]): any[] {
  return rows.filter(row => String(row.bookingStatus || '').replace(/\s+/g, '').toLowerCase() === 'waitingforpayment')
    .map(row => {
      let config: any = {};
      try { config = typeof row.config === 'string' ? JSON.parse(row.config) : row.config || {}; } catch { }
      const duration = config?.expiryDuration == null ? NaN : Number(config.expiryDuration);
      const created = new Date(row.createdAt || row.bookingDateTime).getTime();
      const expires = duration > 0 && Number.isFinite(created) ? created + duration * 60000 : null;
      return {
        row, created: Number.isFinite(created) ? created : Number.MAX_SAFE_INTEGER,
        expires, unlimited: duration === -1,
        canPay: String(row.paymentType || '').toLowerCase() !== 'cash'
          && (duration === -1 || (duration > 0 && expires > Date.now()))
      };
    }).sort((a, b) => a.created - b.created);
}

@Component({
  selector: 'app-pending-payments',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './pending-payments.component.html',
  styleUrls: ['./pending-payments.component.css']
})
export class PendingPaymentsComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public items: any[]) { }
}
